import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 64 64\" id=\"chevron\">\n  <path fill-rule=\"evenodd\" d=\"M55.636 19.431c-1.872-1.834-4.493-1.98-6.793 0L32 34.861 15.157 19.43c-2.3-1.98-4.922-1.834-6.793 0-1.879 1.834-1.757 4.929 0 6.65L28.607 44.62A4.837 4.837 0 0 0 32 45.998a4.837 4.837 0 0 0 3.393-1.38s18.485-16.814 20.243-18.536c1.757-1.722 1.878-4.817 0-6.65z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol